// extracted by mini-css-extract-plugin
export default {"editPropertyButton":"EditPropertyButton_editPropertyButton__W-017"};